export * from "./dialog-confirmation-isAlive.component";
